<template>
  <a-modal
    title="添加沟通记录"
    :confirmLoading="loading"
    :destroyOnClose="true"
    v-model="visible"
    @ok="handleOk"
  >
    <a-form :form="form">
      <a-form-item label="沟通记录">
        <a-textarea
          :rows="6"
          v-decorator="[
            'content',
            { rules: [{ required: true, message: '请填写沟通记录' }] },
          ]"
        ></a-textarea>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import Api from "@/api";
export default {
  name: "AddCommunicationModal",
  data() {
    return {
      visible: false,
      loading: false,
      record: {},
      form: this.$form.createForm(this),
      formItemsLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 16 },
      },
    };
  },
  methods: {
    show(record) {
      this.record = { ...record };
      this.visible = true;
    },
    close() {
      this.visible = false;
    },
    handleOk() {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          this.loading = true;
          try {
            await Api.resume.createCommunication({
              ...values,
              resume_id: this.record.resume_id,
            });
            this.close();
            this.$emit("ok");
          } catch (e) {}
          this.loading = false;
        }
      });
    },
  },
};
</script>
